<template>
  <div class="_certificatBox">
    <div class="_certificat"
			v-loading="loading"
			element-loading-text="加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 1)"
		>
			<template v-if="!loading">
				<div class="_top">
					<h3>实名认证</h3>
					<p class="_top_p">根据《中华人民共和国网络安全法》第二十四条规定，需要对本账号进行实名认证。 步峰代理采用支付宝实名认证服务，仅能获取支付宝脱敏后返回的实名认证结果信息。 您的实名信息仍将保留在支付宝，受支付宝数据安全保护。</p>
				</div>
				<div class="_bot" v-if="!cretificatType || cretificatType === null">
					<div class="_left">
						<img src="../../assets/mine_rz2.png" alt="">
						<span @click="showCretificat(1)">个人认证</span>
					</div>
					<div class="_right">
						<img src="../../assets/mine_rz1.png" alt="">
						<span @click="showCretificat(2)">企业认证</span>
					</div>
				</div>
				<div class="_personal" v-if="cretificatType && cretificatType == 1">
					<div class="_top">
						<el-steps :active="active" :align-center="true" :finish-status="finishStatus">
							<el-step title="信息填写"></el-step>
							<el-step title="扫脸认证"></el-step>
							<el-step :title="stepTitle"></el-step>
						</el-steps>
					</div>
					<div class="_personalForm">
						<el-form
							:model="plForm"
							:rules="plRules"
							ref="plForm"
							label-width="100px"
							class="ruleForm"
						>
							<template v-if="type == 0 || type == 3">
								<el-form-item label="真实姓名：" prop="real_name">
									<el-input  v-model="plForm.real_name" clearable placeholder="请输入真实姓名" />
								</el-form-item>
								<el-form-item label="证件类型：" prop="id_card_type">
									<el-select  v-model="plForm.id_card_type" style="width:100%;" clearable placeholder="请选择证件类型">
										<el-option
											v-for="item in cardTypeList"
											:key="item.type"
											:label="item.name"
											:value="item.type"
										/>
									</el-select>
								</el-form-item>
								<el-form-item label="证件号码：" prop="id_card">
									<el-input  v-model="plForm.id_card" clearable placeholder="请输入证件号码" />
								</el-form-item>
							</template>
							<template v-else>
								<el-form-item label="真实姓名：">
									{{ plForm.real_name }}
								</el-form-item>
								<el-form-item label="证件类型：">
									{{ getCardType(plForm.id_card_type) }}
								</el-form-item>
								<el-form-item label="证件号码：">
									{{ plForm.id_card }}
								</el-form-item>
							</template>
						</el-form>
						<div class="_button"  v-if="type !== 1 && type !== 2"  >
							<p class="_button_p" v-if="active === 0 && type === 0" @click="stepBack">上一步</p>
							<p class="_button_p" @click="validateForm('plForm')">{{type == 3 ? '重新' : ''}}提交</p>
						</div>
					</div>
				</div>
				<div class="_enterprise" v-if="cretificatType && cretificatType == 2">
					<div class="_top">
						<el-steps :active="active" :align-center="true" :finish-status="finishStatus">
							<el-step title="信息填写" :status="finishStatus"></el-step>
							<el-step title="信息审核"></el-step>
							<el-step title="认证人扫脸认证"></el-step>
							<el-step :title="stepTitle"></el-step>
						</el-steps>
					</div>
					<div class="_personalForm">
						<el-form
							:model="epForm"
							:rules="epRules"
							ref="epForm"
							label-width="200px"
							class="ruleForm"
						>
							<template v-if="type == 0 || type == 3 || resubmit_status">
								<el-form-item label="企业名称：" prop="company_name">
									<el-input  v-model="epForm.company_name" clearable placeholder="请输入企业名称" />
								</el-form-item>
								<el-form-item label="统一社会信用代码：" prop="social_code">
									<el-input  v-model="epForm.social_code" clearable placeholder="请输入统一社会信用代码" />
								</el-form-item>
								<el-form-item label="营业执照：" prop="business_license">
									<template>
										<div class="uploader-box">
											<el-image
												v-if="epForm.business_license"
												:src="epForm.business_license"
												fit="cover"
												:preview-src-list="[epForm.business_license]"
											/>
											<el-upload
												class="uploader"
												drag
												action="#"
												:http-request="(params) => updataFileImg(params, 'business_license')"
												:show-file-list="false"
												:auto-upload="true"
												:before-upload="beforeUpload"
											>
												<div class="drag-box">
													<i class="el-icon-upload"></i>
													<div class="drag-text">点击或拖拽上传</div>
													<div class="el-upload__tip">仅限1张 jpg/jpeg/png，≤10MB</div>
												</div>
											</el-upload>
										</div>
									</template>
								</el-form-item>
								<el-form-item label="认证人姓名：" prop="real_name">
									<el-input v-model="epForm.real_name" clearable placeholder="请输入认证人姓名" />
								</el-form-item>
								<el-form-item label="证件类型：" prop="id_card_type">
									<el-select  v-model="epForm.id_card_type" style="width:100%;" clearable placeholder="请选择证件类型">
										<el-option
											v-for="item in cardTypeList"
											:key="item.type"
											:label="item.name"
											:value="item.type"
										/>
									</el-select>
								</el-form-item>
								<el-form-item label="证件号：" prop="id_card">
									<el-input  v-model="epForm.id_card" clearable placeholder="请输入证件号码" />
								</el-form-item>
								<el-form-item label="身份信息：" prop="proxy_form_type">
									<el-select  v-model="epForm.proxy_form_type" style="width:100%;" placeholder="请选择身份信息">
										<el-option label="法定代表人" :value="1"></el-option>
										<el-option label="被授权人" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="授权书：" prop="proxy_form" v-if="epForm.proxy_form_type == 2">
									<template>
										<div class="uploader-box">
											<el-image
												v-if="epForm.proxy_form"
												:src="epForm.proxy_form"
												fit="cover"
												:preview-src-list="[epForm.proxy_form]"
											/>
											<el-upload
												class="uploader"
												drag
												action="#"
												:http-request="(params) => updataFileImg(params, 'proxy_form')"
												:show-file-list="false"
												:auto-upload="true"
												:before-upload="beforeUpload"
											>
												<div class="drag-box">
													<i class="el-icon-upload"></i>
													<div class="drag-text">点击或拖拽上传</div>
													<div class="el-upload__tip">仅限1张 jpg/jpeg/png，≤10MB</div>
												</div>
											</el-upload>
										</div>
									</template>
								</el-form-item>
							</template>
							<template v-else>
								<el-form-item label="企业名称：">
									{{ epForm.company_name }}
								</el-form-item>
								<el-form-item label="统一社会信用代码：">
									{{ epForm.social_code }}
								</el-form-item>
								<el-form-item label="营业执照：">
									<template>
										<div class="uploader-box">
											<el-image
												:src="epForm.business_license"
												fit="cover"
												:preview-src-list="[epForm.business_license]"
											/>
										</div>
									</template>
								</el-form-item>
								<el-form-item label="认证人姓名：">
									{{ epForm.real_name }}
								</el-form-item>
								<el-form-item label="证件类型：">
									{{ getCardType(epForm.id_card_type) }}
								</el-form-item>
								<el-form-item label="证件号：">
									{{ epForm.id_card }}
								</el-form-item>
								<el-form-item label="身份信息：">
									{{ epForm.proxy_form_type == 1 ? '法定代表人' : '被授权人' }}
								</el-form-item>
								<el-form-item label="授权书：" v-if="epForm.proxy_form_type == 2">
									<template>
										<div class="uploader-box">
											<el-image
												v-if="epForm.proxy_form"
												:src="epForm.proxy_form"
												fit="cover"
												:preview-src-list="[epForm.proxy_form]"
											/>
										</div>
									</template>
								</el-form-item>
							</template>
						</el-form>
						<div class="_button">
							<p class="_button_p" v-if="active === 0 && type === 0" @click="stepBack">上一步</p>
							<p class="_button_p" v-if="type == 0 || type == 3" @click="validateForm('epForm')">
								{{type == 3 ? '重新' : ''}}提交
							</p>
							<template v-if="!resubmit_status && type == 4">
								<p class="_button_p" @click="reSubmit">信息重填</p>
								<p class="_button_p" @click="submitPl(epForm)">去认证</p>
							</template>
							<template v-if="resubmit_status">
								<p class="_button_p" @click="getInfoData">取消重填</p>
								<p class="_button_p" @click="validateForm('epForm')">
									提交
								</p>
							</template>
						</div>
					</div>
				</div>
			</template>
		</div>
		<Certif v-if="show" :qrdata="qrdata" @hide="hide" />
  </div>
</template>

<script>
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
import Certif from './_certif.vue'
export default {
	name:"cretificat",
	components:{
		Certif
	},
	data(){
		return {
			show:false,
			qrdata:null,
			cretificatType: null,
			active:3,
			plForm:{
				real_name: '',
				id_card:'',
				id_card_type:1,
			},
			plRules:{
				real_name: [
					{ required: true, message: '请输入真实姓名', trigger: 'blur' }
				],
				id_card_type: [
					{ required: true, message: '请选择证件类型', trigger: 'change' },
				],
				id_card: [
					{ required: true, message: '请输入证件号码', trigger: 'blur' },
				],
			},
			epForm:{
				company_name: '',
				social_code:'',
				business_license:'',
				send_business_license: '',
				real_name: '',
				id_card_type: 1,
				id_card: '',
				proxy_form_type: '',
				proxy_form: '',
				send_proxy_form: '',
			},
			epRules:{
				company_name: [
					{ required: true, message: '请输入企业名称', trigger: 'blur' },
				],
				social_code: [
					{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
					{ validator: this.isSocialCode, trigger: 'blur' }
				],
				business_license: [
					{ required: true, message: '请上传营业执照', trigger: 'change' },
				],
				real_name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				id_card_type: [
					{ required: true, message: '请选择证件类型', trigger: 'change' },
				],
				id_card: [
					{ required: true, message: '请输入证件号码', trigger: 'blur' },
				],
				proxy_form_type: [
					{ required: true, message: '请选择身份信息', trigger: 'change' },
				],
				proxy_form: [
					{ required: true, message: '请上传授权书', trigger: 'change' },
				],
			},
			infoData:null,
			type:'',
			stepTitle:'',
			loading: true,
			cardTypeList: [
				{type: 1, name: '身份证'},
				{type: 2, name: '港澳通行证护照'},
				{type: 3, name: '台湾通行证'},
				{type: 4, name: '港澳居住证'},
				{type: 5, name: '台湾居住证'},
			],
			access_token: '',
			reg: {
				code: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
				img: /\.(jpg|jpeg|png)$/i
			},
			finishStatus: '',
			resubmit_status: false
		}
	},
	created(){
		this.access_token = this.$store.state.access_token
		this.getInfoData()
	},
	methods:{
		reSubmit() {
			this.$confirm('重新填写信息将会重新审核, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.resubmit_status = true
				this.active = 0
				this.finishStatus = ''
			}).catch(() => {
				          
			});
		},
		getCardType(type) {
			return this.cardTypeList.find(item => item.type == type)?.name || ''
		},
		hide(data){
			this.show = false
			if (data.flag == 1) {
				this.getInfoData()
			}
			if (data.flag == 2) {
				this.$confirm(`失败原因：${data.msg}`, '认证失败', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
					this.showCretificat(1)
				})
			}
		},
		showCretificat(type){
			this.cretificatType = type
		},
		beforeUpload(file) {
      const isImage = this.reg.img.test(file.name) && (file.type === 'image/jpeg' || file.type === 'image/png');
      if (!isImage) {
        this.$message.error('只能上传图片类型文件！')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片不能超过 10MB！')
        return false
      }
      return true
    },
		updataFileImg(params, type){
			const formData = new FormData()
      formData.append('file', params.file)
			formData.append('access_token',this.$store.state.access_token);
			request({
				method: 'formdata', 
				url: Apis.upload,
				params:formData
			}).then(res => {
				if(res.code == 0){
					const str = `send_${type}`
					this.epForm[type] = res.show_url
					this.epForm[str] = res.url
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		stepBack(){
			this.cretificatType = null
		},
		isSocialCode(rule, value, callback) {
			if (!this.reg.code.test(value)) {
				return callback(new Error('请输入正确的代码或注册号'))
			}
			callback()
		},
		getInfoData(){
			request({
				method: 'get', 
				url: Apis.readMemberInfo,
				params: {
					access_token:this.access_token
				}
			}).then(res => {
				if(res.code == 0){
					/* 
						0 未实名
						1 已实名
						2 审核中
						3 审核不通过
						4 企业待人脸核实
					*/
					this.resubmit_status = false
					this.infoData = res.data
					this.type = res.data.is_realname
					if (res.data.is_realname !== 0) {
						if (res.data.is_company == 1) {
							this.epForm = {
								company_name: res.data.company_name,
								social_code: res.data.social_code,
								business_license: res.data.business_license_url,
								send_business_license: res.data.business_license,
								real_name: res.data.real_name,
								id_card_type: res.data.id_card_type,
								id_card: res.data.id_card,
								id_card_un: res.data.id_card_un,
								proxy_form_type: res.data.proxy_form_type,
								proxy_form: res.data.proxy_form_url,
								send_proxy_form: res.data.proxy_form,
							}
						} else {
							this.plForm = {
								real_name: res.data.real_name,
								id_card: res.data.id_card,
								id_card_type: res.data.id_card_type
							}
						}
					}
					this.$store.commit("setMineData", res.data);
					this.active = this.getStepActive(res.data.is_realname, res.data.is_company)
					this.stepTitle = this.getStepTitle(res.data.is_realname, res.data.is_company)
					if (res.data.is_realname !== 0) {
						this.cretificatType = res.data.is_company + 1
					}
					this.finishStatus = this.type == 3 ? 'error' : 'success'
					this.$nextTick(() => {})
				}else{
					this.$message.error(res.msg);
				}
				this.loading = false
			});
		},
		getStepTitle(type, is_company){
			return type == 3 ? '审核不通过' : '认证通过'
		},
		getStepActive(type, is_company){
			if (is_company == 1) {
				switch(type) {
					case 0:
					case 3:
						return 0
					case 2:
						return 1
					case 4:
						return 2
					case 1:
						return 4
				}
			} else {
				return type == 1 || type == 3 ? 3 : type
			}
		},
		validateForm(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (formName == 'plForm') {
						this.submitPl(this.plForm)
					} else {
						this.submitEp()
					}
				} else {
					return false;
				}
			});
		},
		submitPl(form){
			const data = {
				real_name:form.real_name,
				id_card:form.id_card_un ? form.id_card_un : form.id_card,
				id_card_type:form.id_card_type,
				access_token:this.access_token
			}
			request({
				method: 'post', 
				url: Apis.getAuthUrl,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.qrdata = {
						...res.data,
						sendData: data
					}
					this.show = true
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		submitEp(){
			const data = {
				company_name:this.epForm.company_name,
				social_code:this.epForm.social_code,
				business_license:this.epForm.send_business_license,
				real_name: this.epForm.real_name,
				id_card_type: this.epForm.id_card_type,
				id_card: this.epForm.id_card,
				proxy_form_type: this.epForm.proxy_form_type,
				proxy_form: this.epForm.send_proxy_form,
				access_token:this.access_token,
			}
			request({
				method: 'post', 
				url: Apis.authCompany,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: res.data,
						showClose: true,
						duration:1500,
						type: 'success'
					});
					this.getInfoData()
				}else{
					this.$message.error(res.msg);
				}
			});
		},
	}
}
</script>

<style lang="less" scoped>
._certificatBox{
	width: 100%;
	._certificat{
		width:100%;
		background: #fff;
		min-height: 880px;
		._top{
			width: 672px;
			margin: 0 auto;
			h3{
				display: inline-block;
				font-size: 22px;
				color: #242323;
				font-weight: bold;
				margin-top: 40px;
			}
			._top_p{
				font-size: 18px;
				color: #1E1D1D;
				line-height: 36px;
				margin-top: 29px;
			}
		}
		._bot{
			width: 496px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			._left , ._right{
				width: 128px;
				min-height: 190px;
				margin-top: 170px;
				// display: flex;
				img{
					width: 88px;
					height: 88px;
					margin: 0 auto;
				}
				span{
					display: inline-block;
					width: 127px;
					height: 51px;
					margin-top: 60px;
					text-align: center;
					color: #242323;
					border: 1px solid #BBBBBB;
					border-radius: 6px;
					color: #242323;
					font-size: 18px;
					line-height: 51px;
					cursor:pointer;
				}
				span:hover{
					background: #1F8EFF;
					color: #fff;
					
				}
			}
		}
		._personal{
			width: 770px;
			margin: 0 auto;
			._top{
				margin-top: 72px;
			}
			._personalForm{
				width: 700px;
				margin: 0 auto;
				margin-top: 60px;
				._button{
					width: 100%;
					margin-top: 70px;
					display: flex;
					justify-content: center;
					._button_p{
						width: 120px;
						height: 50px;
						border-radius: 6px;
						background: #1F8EFF;
						color: #fff;
						font-weight: bold;
						font-size: 18px;
						text-align: center;
						line-height: 50px;
						cursor: pointer;
					}
					._button_p:nth-child(2){
						margin-left: 50px;
					}
				}
			}
		}
		._enterprise{
			width: 770px;
			margin: 0 auto;
			padding-bottom: 15px;
			._top{
				margin-top: 72px;
			}
			._personalForm{
				width: 700px;
				margin: 0 auto;
				margin-top: 60px;
				._idCard{
					width: 100%;
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;
					margin-bottom: 20px;
					.upload-img{
						width: 231px;
						height: 147px;
						margin-left: 20px;
						position: relative;
						._ImgUp{
							width: 100%;
							height: 100%;
							background: red;
							opacity: 0;
							z-index: 99;
							position: absolute;
							top: 8px;
							left: 0;
							cursor: pointer;
						}
					}
					._left, ._right{
						width: 231px;
						height: 147px;
						display: flex;
						justify-content: flex-start;
						align-items: flex-start;
						
						
						img{
							width: 100%;
							height: 100%;
							position: absolute;
							top: 8px;
							left: 0;
							z-index: 1;
							object-fit: cover;
						}
					}
					._right{
						cursor: pointer;
					}
				}
				._button{
					width: 100%;
					margin-top: 70px;
					display: flex;
					justify-content: center;
					._button_p{
						width: 120px;
						height: 50px;
						border-radius: 6px;
						background: #1F8EFF;
						color: #fff;
						font-weight: bold;
						font-size: 18px;
						text-align: center;
						line-height: 50px;
						cursor: pointer;
					}
					._button_p:nth-child(2){
						margin-left: 50px;
					}
				}
			}
		}
	}
	::v-deep .uploader-box{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		.el-image{
			width: 240px;
			height: 144px;
			margin-right: 20px;
		}
		.uploader{
			display: flex;
			justify-content: flex-start;
			.el-upload-dragger{
				width: 240px;
				height: 144px;
			}
			.drag-box{
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				.el-icon-upload{
					margin: 0;
				}
				.drag-text, .el-upload__tip{
					margin-top: 10px;
					height: 30px;
					line-height: 30px;
				}
				.el-upload__tip{
					margin-top: 0;
				}
			}
		}
	}
}
::v-deep .ruleForm{
	.el-form-item__content{
		display: flex;
	}
}
</style>